module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel slider-navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "containerItem"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('a', {
      staticClass: "topBlock",
      style: (("background-image: url(\"" + (item.img) + "\")")),
      attrs: {
        "href": item.href_img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [(item.header) ? _c('a', {
      staticClass: "ttl",
      attrs: {
        "href": item.href_name
      },
      domProps: {
        "innerHTML": _vm._s(item.header)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "priceAndBuy"
    }, [_c('div', {
      staticClass: "priceContainer"
    }, [(item.sale) ? _c('p', {
      staticClass: "sale",
      domProps: {
        "innerHTML": _vm._s(item.sale)
      }
    }) : _vm._e(), _vm._v(" "), (item.oldPrice) ? _c('p', {
      staticClass: "oldPrice",
      domProps: {
        "innerHTML": _vm._s(item.oldPrice)
      }
    }) : _vm._e(), _vm._v(" "), (item.price) ? _c('p', {
      staticClass: "price",
      domProps: {
        "innerHTML": _vm._s(item.price)
      }
    }) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "buy waves-effect waves-light sale",
      attrs: {
        "href": item.href_button
      }
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "24",
        "viewBox": "0 0 24 24",
        "width": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0-.25h24v24H0z",
        "fill": "none"
      }
    })])])])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3babc336"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/catalogVuesliderToSections.vue
// module id = 244
// module chunks = 35